// 上帝图的相关请求
import req from './index'

export const getAllPromptQuantities = (param) => {
  return req.get('api/admin.php?s=Admin.Airport.InsCount_Get', param)
}
